// @flow
import * as React from 'react';
import MaterialUILayout from 'material-ui-layout';

import AppBar from '~components/AppBar';
import Footer from '~components/Footer';
import Drawer from '~components/Drawer';
import CookieConsent from '~plugins/prismic-cookies/components/CookieConsent';

export type Props = {
  children: React.Node,
};

const BaseLayout = ({ children }: Props) => (
  <>
    <MaterialUILayout
      mainGrow={false}
      stickyFooter
      appBarContent={<AppBar />}
      footerContent={<Footer />}
      rightDrawerContent={<Drawer position="right" />}
    >
      {children}
    </MaterialUILayout>
    <CookieConsent showReadMore />
  </>
);

export default BaseLayout;
